import styles from "./loadingTitleDots.module.css";

/** Animated ellipsis after loading copy (hidden from screen readers on parent). */
export const LoadingTitleDots = () => (
  <span className={styles.dots} aria-hidden>
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
  </span>
);
